import React, { useState, useEffect } from "react";
import { UTILS } from "../config/API";
import TaxPayments from "../components/PbTaxReturn/SalesTaxReport";
import StampsInventory from "../components/PbTaxReturn/StampsInventory";
import PacksInventory from "../components/PbTaxReturn/PacksInventory";
import UnstampPacks from "../components/PbTaxReturn/UnstampPacks";
import OffReservation from "../components/PbTaxReturn/OffReservation";
import NPMSales from "../components/PbTaxReturn/NPMSales";
import StampInvoices from "../components/PbTaxReturn/StampInvoices";
import FuelInventory from "../components/PbTaxReturn/FuelInventory";
import TaxInfo from "../components/PbTaxReturn/TaxInfo";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const tabs = [
  { id: 1, label: "Tax Revenue Information", icon: "📋" },
  { id: 2, label: "Stamps Inventory", icon: "🏷️" },
  { id: 3, label: "Packs Inventory", icon: "📦" },
  { id: 4, label: "Unstamped Packs", icon: "❌" },
  { id: 5, label: "Off-Reservation Packs", icon: "📍" },
  { id: 6, label: "NPM Sales", icon: "💰" },
  { id: 7, label: "Stamp Invoices", icon: "🧾" },
  { id: 8, label: "Fuel Inventory", icon: "⛽" },
  { id: 9, label: "Tax Payments", icon: "💳" },
];

const TaxReturnPb = () => {
  const [activeTab, setActiveTab] = useState(1);
  const [formDataCache, setFormDataCache] = useState({});
  const [taxInfoData, setTaxInfoData] = useState({});
  const [stampsInventoryData, setStampsInventoryData] = useState([]);
  const [packsInventoryData, setPacksInventoryData] = useState([]);
  const [unstampPacksData, setUnstampPacksData] = useState([]);
  const [offReservationData, setOffReservationData] = useState([]);
  const [npmSalesData, setNpmSalesData] = useState([]);
  const [stampInvoicesData, setStampInvoicesData] = useState([]);
  const [fuelInventoryData, setFuelInventoryData] = useState([]);
  const [taxPaymentsData, setTaxPaymentsData] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitResult, setSubmitResult] = useState(null);
  const [showDownloadPopup, setShowDownloadPopup] = useState(false);
  const [submittedData, setSubmittedData] = useState(null);
  const [taxPayerName, setTaxPayerName] = useState("");


  // Get tax payer name from localStorage
  useEffect(() => {
    const selectedTaxPayer = localStorage.getItem("selectedBusinessName");
    if (selectedTaxPayer) {
      setTaxPayerName(selectedTaxPayer);
    }
  }, []);

  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  // Generic data update handler for all tabs
  const updateTabData = (tabId, data) => {
    setFormDataCache((prev) => ({
      ...prev,
      [tabId]: data,
    }));
    
    // Update specific tab data based on tab ID
    switch(tabId) {
      case 1:
        setTaxInfoData(data);
        break;
      case 2:
        setStampsInventoryData(data.stampsInventory || data || []);
        break;
      case 3:
        setPacksInventoryData(data.packsInventory || data || []);
        break;
      case 4:
         setUnstampPacksData(data.unstampPacks || data || []);
        break;
      case 5:
        setOffReservationData(data.offReservation || data || []);
        break;
      case 6:
        setNpmSalesData(data.npmSales || data || []);
        break;
      case 7:
        setStampInvoicesData(data.stampInvoices || data || []);
        break;
      case 8:
        setFuelInventoryData(data.fuelInventory || data || []);
        break;
      case 9:
        setTaxPaymentsData(data.taxPayments || data || []);
        break;
      default:
        console.log(`Unknown tab ${tabId} data:`, data);
    }
  };

  // Navigation functions with scroll to top
  const goToNextTab = () => {
    
    
    if (activeTab < tabs.length) {
      setActiveTab(activeTab + 1);
      // Scroll to top after tab change
      setTimeout(() => {
        scrollToTop();
      }, 100);
    }
  };

  const goToPreviousTab = () => {
    if (activeTab > 1) {
      setActiveTab(activeTab - 1);
      // Scroll to top after tab change
      setTimeout(() => {
        scrollToTop();
      }, 100);
    }
  };

  // Also add scroll to top when clicking on tab buttons directly
  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
    // Scroll to top after tab change
    setTimeout(() => {
      scrollToTop();
    }, 100);
  };

  // API Submission Function
  const submitTaxReturnData = async (allFormData) => {
    const taxPayer = localStorage.getItem("selectedTaxPayer");
    try {
      // Prepare the request data structure
       
      const requestData = {
        
        contractorid: taxPayer, 
        taxInfo: allFormData.taxInfo,
        stampsInventory: allFormData.stampsInventory,
        packsInventory: allFormData.packsInventory,
        unstampPacks: allFormData.unstampPacks,
        offReservation: allFormData.offReservation,
        npmSales: allFormData.npmSales,
        stampInvoices: allFormData.stampInvoices,
        fuelInventory: allFormData.fuelInventory,
        taxPayments: allFormData.taxPayments,
      };

      console.log("Prepared request data:", JSON.stringify(requestData, null, 2));

      const fetchUrl = `${UTILS}?action=taxreturnpbp`;

      const response = await fetch(fetchUrl, {
        method: "POST",
        headers: {
          'Content-Type': 'text/plain'
        },
        body: JSON.stringify(requestData)
      });
      console.log(JSON.stringify(requestData))

      // Handle potential BOM and control characters in response
      const text = await response.text();
      const cleanedText = text.replace(/^[\uFEFF\x00-\x1F\x7F-\x9F]+|[\uFEFF\x00-\x1F\x7F-\x9F]+$/g, "");
      
      let data;
      try {
        data = JSON.parse(cleanedText);
      } catch (parseError) {
        console.error("Failed to parse response:", {
          error: parseError,
          responseText: text,
          cleanedText: cleanedText
        });
        throw new Error("Invalid server response format");
      }

      console.log("Server response:", data);

      if (data.status === "success") {
        return { success: true, message: data.message || "Submission successful" };
      } else {
        throw new Error(data.message || "Submission failed");
      }
    } catch (error) {
      console.error("Submission error:", {
        error: error,
        message: error.message,
        stack: error.stack
      });
      return { success: false, message: error.message || "An unknown error occurred" };
    }
  };

  // Generate PDF function
  const generatePDF = (pdfFormData, pdfTaxPayerName) => {
    const doc = new jsPDF({ unit: "pt", format: "a4" });

    doc.setProperties({
      title: "PB Tax Return Summary",
      subject: "PB Tax Return PDF",
      creator: "Tax Portal",
    });

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const brand = { r: 113, g: 21, b: 21 }; // #711515
    const topMargin = 110;
    const bottomMargin = 60;
    const sideMargin = 30;

    const drawHeader = (pageNumber) => {
      doc.setFillColor(brand.r, brand.g, brand.b);
      doc.rect(0, 0, pageWidth, 70, "F");

      doc.setTextColor(0, 0, 0);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(16);
      doc.text("PB Tax Return Summary", sideMargin, 30);

      doc.setFont("helvetica", "normal");
      doc.setFontSize(11);
      const now = new Date().toLocaleString();
      doc.text(`Generated: ${now}`, sideMargin, 50);

      const forText = `For: ${pdfTaxPayerName || "N/A"}`;
      const forWidth = doc.getTextWidth(forText);
      doc.text(forText, pageWidth - sideMargin - forWidth, 50);
    };

    const drawFooter = (pageNumber, totalPages) => {
      doc.setFillColor(245, 247, 250);
      doc.rect(0, pageHeight - 50, pageWidth, 50, "F");

      doc.setTextColor(0, 0, 0);
      doc.setFont("helvetica", "normal");
      doc.setFontSize(10);

      const refText = `Ref: ${String(new Date().getTime()).slice(-8)}`;
      doc.text(refText, sideMargin, pageHeight - 20);

      const pageText = `Page ${pageNumber} of ${totalPages}`;
      const pageWidthText = doc.getTextWidth(pageText);
      doc.text(pageText, pageWidth - sideMargin - pageWidthText, pageHeight - 20);
    };

    const tableOpts = {
      margin: {
        top: topMargin,
        bottom: bottomMargin,
        left: sideMargin,
        right: sideMargin,
      },
      styles: {
        font: "helvetica",
        fontSize: 10,
        cellPadding: 6,
        textColor: 33,
        lineWidth: 0.1,
        lineColor: [226, 232, 240],
      },
      headStyles: {
        fillColor: [brand.r, brand.g, brand.b],
        textColor: 255,
        fontStyle: "bold",
        halign: "left",
        valign: "middle",
      },
      alternateRowStyles: {
        fillColor: [249, 250, 251],
      },
      bodyStyles: {
        valign: "top",
      },
      theme: "striped",
    };

    drawHeader(1);

    // Tax Info Section
    const taxInfoRows = Object.entries(pdfFormData.taxInfo || {}).map(
      ([key, value]) => [key, String(value)]
    );

    autoTable(doc, {
      ...tableOpts,
      startY: topMargin + 12,
      head: [["Tax Information", "Value"]],
      body: taxInfoRows,
    });

    let cursorY = doc.lastAutoTable ? doc.lastAutoTable.finalY + 20 : topMargin + 20;

    const ensureSpace = (needed = 120) => {
      if (cursorY > pageHeight - bottomMargin - needed) {
        doc.addPage();
        drawHeader(doc.getNumberOfPages());
        cursorY = topMargin + 10;
      }
    };

    // Stamps Inventory Section
    if (pdfFormData.stampsInventory && pdfFormData.stampsInventory.length > 0) {
      ensureSpace(140);
      doc.setDrawColor(229, 231, 235);
      doc.setFillColor(241, 245, 249);
      doc.roundedRect(
        sideMargin,
        cursorY,
        pageWidth - sideMargin * 2,
        28,
        6,
        6,
        "F"
      );

      doc.setTextColor(0, 0, 0);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(12);
      doc.text("Stamps Inventory", sideMargin + 10, cursorY + 18);
      cursorY += 42;

      const stampsRows = pdfFormData.stampsInventory.map(item => 
        Object.values(item)
      );

      autoTable(doc, {
        ...tableOpts,
        startY: cursorY,
        head: [Object.keys(pdfFormData.stampsInventory[0] || {})],
        body: stampsRows,
      });
      cursorY = doc.lastAutoTable ? doc.lastAutoTable.finalY + 16 : cursorY + 16;
    }

    // Repeat similar sections for other data types...

    const totalPages = doc.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      drawHeader(i);
      drawFooter(i, totalPages);
    }

    doc.setDisplayMode("fullwidth");

    doc.save("pb-tax-return-form.pdf");
  };

  const handleSubmit = async () => {
    // Include all data in the final submission
    const allFormData = {
      taxInfo: taxInfoData,
      stampsInventory: stampsInventoryData,
      packsInventory: packsInventoryData,
      unstampPacks: unstampPacksData,
      offReservation: offReservationData,
      npmSales: npmSalesData,
      stampInvoices: stampInvoicesData,
      fuelInventory: fuelInventoryData,
      taxPayments: taxPaymentsData,
    };
    
    console.log("Complete form data submission:", allFormData);
    
    setIsSubmitting(true);
    setSubmitResult(null);
    
    try {
      const result = await submitTaxReturnData(allFormData);
      
      if (result.success) {
        // Capture data BEFORE resetting
        setSubmittedData(allFormData);
        setShowDownloadPopup(true);
        
        // Clear form data after successful submission
        setFormDataCache({});
        setTaxInfoData({});
        setStampsInventoryData([]);
        setPacksInventoryData([]);
        setUnstampPacksData([]);
        setOffReservationData([]);
        setNpmSalesData([]);
        setStampInvoicesData([]);
        setFuelInventoryData([]);
        setTaxPaymentsData([]);
      } else {
        setSubmitResult({ type: 'error', message: result.message });
      }
    } catch (error) {
      setSubmitResult({ type: 'error', message: error.message || "An unknown error occurred" });
    } finally {
      setIsSubmitting(false);
    }
  };

  const renderTabs = () =>
    tabs.map((tab) => {
      const isActive = activeTab === tab.id;
      const commonProps = {
        key: tab.id,
        style: { display: isActive ? "block" : "none" },
      };

      // Common props for all form components
      const formComponentProps = {
        initialData: formDataCache[tab.id] || {},
        onDataChange: (data) => updateTabData(tab.id, data)
      };

      switch(tab.id) {
        case 1:
          return (
            <div {...commonProps}>
              <TaxInfo {...formComponentProps} />
            </div>
          );
        case 2:
          return (
            <div {...commonProps}>
              <StampsInventory {...formComponentProps} />
            </div>
          );
        case 3:
          return (
            <div {...commonProps}>
              <PacksInventory {...formComponentProps} />
            </div>
          );
        case 4:
          return (
            <div {...commonProps}>
              <UnstampPacks {...formComponentProps} />
            </div>
          );
        case 5:
          return (
            <div {...commonProps}>
              <OffReservation {...formComponentProps} />
            </div>
          );
        case 6:
          return (
            <div {...commonProps}>
              <NPMSales {...formComponentProps} />
            </div>
          );
        case 7:
          return (
            <div {...commonProps}>
              <StampInvoices {...formComponentProps} />
            </div>
          );
        case 8:
          return (
            <div {...commonProps}>
              <FuelInventory {...formComponentProps} />
            </div>
          );
        case 9:
          return (
            <div {...commonProps}>
              <TaxPayments {...formComponentProps} />
            </div>
          );
        default:
          return null;
      }
    });

  // Show confirmation before leaving if there's unsaved data
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (Object.keys(formDataCache).length > 0) {
        e.preventDefault();
        e.returnValue = 'You have unsaved changes. Are you sure you want to leave?';
        return e.returnValue;
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [formDataCache]);

  return (
    <div className="tax-return-pb max-w-7xl mx-auto min-h-screen flex flex-col bg-gray-50 p-6">
      <header className="mb-8 text-center">
        <h1 className="text-4xl font-bold text-[#711515] tracking-wide bg-gradient-to-r from-[#711515] to-[#a82a2a] bg-clip-text text-transparent">
          Tax Return Portal
        </h1>
        <p className="text-lg text-gray-600 mt-2">Manage your tax submissions efficiently and securely</p>
        <div className="w-24 h-1 bg-gradient-to-r from-[#711515] to-[#a82a2a] mx-auto mt-4 rounded-full"></div>
      </header>

      <div className="bg-white rounded-xl shadow-lg overflow-hidden mb-8">
        <nav className="flex overflow-x-auto whitespace-nowrap no-scrollbar bg-gray-100 px-4" aria-label="Tabs">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => handleTabClick(tab.id)}
              className={`flex-shrink-0 px-6 py-4 cursor-pointer font-medium text-center transition-all duration-200 flex items-center ${activeTab === tab.id
                ? "bg-white text-[#711515] border-b-2 border-[#711515] shadow-sm"
                : "text-gray-600 hover:text-[#711515] hover:bg-gray-50"
                }`}
              aria-current={activeTab === tab.id ? "page" : undefined}
              title={tab.label}
            >
              <span className="mr-2 text-lg">{tab.icon}</span>
              <span>{tab.label}</span>
            </button>
          ))}
        </nav>

        <div className="p-6 bg-white min-h-[400px]">
          <main className="flex-grow">{renderTabs()}</main>
        </div>
      </div>

      <footer className="mt-6 flex justify-between items-center bg-white p-4 rounded-xl shadow-lg">
        <div className="text-sm text-gray-500">
          Step {activeTab} of {tabs.length}
          {formDataCache[activeTab] && Object.keys(formDataCache[activeTab]).length > 0 && (
            <span className="ml-2 text-green-600">• Data saved</span>
          )}
        </div>
        
        <div className="flex space-x-4">
          <button
            type="button"
            onClick={goToPreviousTab}
            disabled={activeTab === 1}
            className={`px-6 py-3 rounded-lg font-medium flex items-center ${activeTab === 1
              ? "bg-gray-100 text-gray-400 cursor-not-allowed"
              : "bg-gray-200 text-gray-700 hover:bg-gray-300 transition-colors"
              }`}
          >
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            Previous
          </button>

          {activeTab === tabs.length ? (
            <button
              type="button"
              onClick={handleSubmit}
              disabled={isSubmitting}
              className="bg-gradient-to-r from-[#711515] to-[#a82a2a] hover:from-[#5a1010] hover:to-[#8a1f1f] text-white font-medium py-3 px-8 rounded-lg shadow-md transition-all duration-200 flex items-center disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isSubmitting ? (
                <>
                  <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Submitting...
                </>
              ) : (
                <>
                  Submit
                  <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </>
              )}
            </button>
          ) : (
            <button
              type="button"
              onClick={goToNextTab}
              className="bg-gradient-to-r from-[#711515] to-[#a82a2a] hover:from-[#5a1010] hover:to-[#8a1f1f] text-white font-medium py-3 px-8 rounded-lg shadow-md transition-all duration-200 flex items-center"
            >
              Next
              <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>
          )}
        </div>
      </footer>

      {submitResult && (
        <div className={`mt-4 p-4 rounded-lg ${
          submitResult.type === 'success' 
            ? 'bg-green-100 text-green-800 border border-green-200' 
            : 'bg-red-100 text-red-800 border border-red-200'
        }`}>
          <div className="flex items-center">
            {submitResult.type === 'success' ? (
              <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
            ) : (
              <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
              </svg>
            )}
            <span>{submitResult.message}</span>
          </div>
        </div>
      )}

      {/* Download Popup */}
      {showDownloadPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-8 rounded-lg shadow-lg text-center max-w-md w-full mx-4">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
              </svg>
            </div>
            
            <h2 className="text-2xl font-bold text-gray-800 mb-2">Form Submitted Successfully</h2>
            <p className="text-gray-600 mb-6">Your PB tax return form has been received. Would you like to download a PDF copy?</p>
            
            <div className="flex flex-col sm:flex-row justify-center space-y-3 sm:space-y-0 sm:space-x-4">
              <button
                onClick={() => setShowDownloadPopup(false)}
                className="bg-gray-500 text-white px-6 py-3 rounded-lg hover:bg-gray-600 transition font-medium"
              >
                Close
              </button>
              <button
                onClick={() => {
                  if (submittedData) {
                    generatePDF(submittedData, taxPayerName);
                  }
                  setShowDownloadPopup(false);
                }}
                className="bg-[#711515] text-white px-6 py-3 rounded-lg hover:bg-[#5a1010] transition font-medium flex items-center justify-center"
              >
                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"></path>
                </svg>
                Download PDF
              </button>
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        .no-scrollbar::-webkit-scrollbar {
          display: none;
        }
        .no-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </div>
  );
};

export default TaxReturnPb;